import "@oddbird/popover-polyfill";

// eslint-disable-next-line
import("./menu.js").then((e) => {
	e.default();
});

/** Add a click to copy option. */
function hydrateShortcodeHelpers(): void {
	const buttons = Array.from(
		document.querySelectorAll("button[data-copy-text]"),
	);
	for (const button of buttons) {
		button.addEventListener("click", () => {
			if (button.textContent) {
				navigator.clipboard
					.writeText(button.textContent.trim())
					.catch((e: unknown) => {
						console.error(e);
					});
			}
		});
	}
}
hydrateShortcodeHelpers();
